var _defs, _metadata, _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) { o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } } return t; }
import * as React from "react";
function SvgDrawPolygon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "62px",
    height: "62px",
    viewBox: "0 0 62 62",
    id: "svg841",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs845"
  })), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title833"
  }, "polygon_select") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title833"
  }, title) : null, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", {
    id: "metadata904"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m 34.350723,4.0557367 19.515496,19.9782713 -9.138937,0.365675 3.908729,9.674444 -3.708736,1.498427 -3.908729,-9.674444 -6.828021,6.085394 z",
    id: "Combined-Shape-9",
    stroke: "#ffffff",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1505",
    transform: "translate(1.1308595,0.08233726)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 44.611536,58.372261 9.7254884,28.443609 33.219864,3.9733994",
    id: "Path",
    stroke: "#fff",
    strokeWidth: 2.87532,
    strokeDasharray: "9, 3",
    style: {
      fill: "none",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#ffffff",
    fill: "#fff",
    x: 41.497437,
    y: 54.986607,
    width: 5.750639,
    height: 5.750639,
    style: {
      fillRule: "evenodd",
      strokeWidth: 0.95844
    }
  }), /*#__PURE__*/React.createElement("rect", {
    id: "rect838",
    stroke: "#ffffff",
    fill: "#fff",
    x: 29.974981,
    y: 1.0980799,
    width: 5.750639,
    height: 5.750639,
    style: {
      fillRule: "evenodd",
      strokeWidth: 0.95844
    }
  }), /*#__PURE__*/React.createElement("rect", {
    id: "rect1247",
    stroke: "#ffffff",
    fill: "#fff",
    x: 6.6687522,
    y: 25.427507,
    width: 5.750639,
    height: 5.750639,
    style: {
      fillRule: "evenodd",
      strokeWidth: 0.95844
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDrawPolygon);
export default __webpack_public_path__ + "static/media/drawPolygon.cdf42c38a7c4558a95fc8409acb9ed76.svg";
export { ForwardRef as ReactComponent };